import React, { useMemo } from 'react';
import { useDashboardFeatureFlags } from '@components';
import { Suggestion } from '@components/common/Suggestion';
import { useShopPayoutQuery } from '@modules/Dashboard/hooks/useShopPayoutQuery';
import { useDashboardStatisticsQuery } from '@queries';
import { routing } from '@utils/routing';
import { useRecommendationsDismiss } from '../../../hooks/useRecommendationsDismiss';
import setUpYourPayouts from '../assets/set-up-your-payouts.png';
export const usePayoutsRecommendation = () => {
    const { recommendationsDismiss, createOnDismiss } = useRecommendationsDismiss();
    const { dashboardFeatureFlags } = useDashboardFeatureFlags();
    const { dashboardStatisticsQuery } = useDashboardStatisticsQuery(undefined, { staleTime: 60_000 });
    const { shopPayoutQuery } = useShopPayoutQuery(undefined, {
        enabled: dashboardFeatureFlags.payoutSetup.enabled, // TODO: Move into dedicated hook.
    });
    // It's ok to return 0 as long as there is no "up to X profit" logic needed for any recommendation.
    const profit = useMemo(() => {
        if (!dashboardStatisticsQuery.isSuccess)
            return 0;
        if (dashboardStatisticsQuery.data.status !== 'DASHBOARD_STATISTICS')
            return 0;
        return dashboardStatisticsQuery.data.profit.amount.value;
    }, [dashboardStatisticsQuery.isSuccess, dashboardStatisticsQuery.data]);
    return {
        payoutsRecommendation: {
            id: 'payouts',
            enabled: profit > 0 &&
                shopPayoutQuery.isSuccess &&
                shopPayoutQuery.data.status === 'INACTIVE' &&
                recommendationsDismiss.payouts.visible,
            isLoading: dashboardStatisticsQuery.isInitialLoading || shopPayoutQuery.isInitialLoading,
            suggestion: (React.createElement(Suggestion, { title: "Set up your payouts", description: "We'll automatically deposit your monthly earnings into your account.", imageUrl: setUpYourPayouts, buttonLabel: "Set up payouts", buttonTo: routing.settings.billing.self, analytics: "setupYourPayouts", onDismiss: createOnDismiss(recommendationsDismiss.payouts.dismiss) })),
        },
    };
};
